import React from 'react';
import { CircleX } from 'lucide-react';

import UserContext from 'context/userContext';
import { cn } from '@epoch-ui/lib/utils';
import { Button } from '@epoch-ui/components/Button';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { useCancelEventModal } from '@event-editor/hooks/eventEditorState';

export const CancelEventSection = (): React.ReactElement => {
  const user = React.useContext(UserContext);

  const cancelEventModal = useCancelEventModal();
  const { calendarDetails, scheduledDeletionAt, hasEnded } = useEditableEvent();

  const isCancelled = !!scheduledDeletionAt;
  const isDisabled = isCancelled || hasEnded;

  const hasOutlookCalendarEvent = !!user?.companyUsesOutlookCalendar;

  let calendarText = '';
  if (calendarDetails?.lastUpdatedAt) {
    calendarText = hasOutlookCalendarEvent ? 'and Outlook Calendar' : 'and Google Calendar';
  }

  return (
    <div>
      <div
        className={cn('tw-flex tw-items-start tw-justify-between', isDisabled && 'tw-opacity-40')}
      >
        <div>
          <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Cancel event</h2>
        </div>
      </div>

      <div className="tw-mt-1 tw-space-y-5">
        <p
          className={cn(
            'tw-m-0 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey',
            isDisabled && 'tw-opacity-40'
          )}
        >
          Canceling this event will remove it from Epoch {calendarText}. You can restore the event
          within 30 days, but not the guest list.
        </p>

        <Button
          variant="destructive"
          size="sm"
          onClick={cancelEventModal.open}
          className="tw-rounded-xl"
          disabled={isDisabled}
        >
          <CircleX className="tw-mr-2 tw-h-4 tw-w-4" />
          Cancel event
        </Button>
      </div>
    </div>
  );
};
